<p>Location and sublocation first time Mapping will be done from DB.</p>

<router-outlet (activate)="onActivate($event)"></router-outlet>